import { objToLabelColorObj } from 'utils/util'

// 状态 key-value值
export const STATUS_OBJ = {
  1: {
    label: '生效中',
    color: 'green',
  },
  2: {
    label: '已取消',
    color: 'gray',
  },
  3: {
    label: '已失效',
    color: 'red',
  },
}
// 申请时可选的信用类型list
export const CREDIT_TYPE_LIST = [
  {
    label: '担保-保证书',
    value: '2',
  },
]
export const STATUS_COLOR_OBJ = objToLabelColorObj(STATUS_OBJ)

// 上传方式
export const ALLOCATE_TYPE_OBJ = {
  1: '普通上传',
  2: '批量上传',
}
